

// /* eslint-disable no-unused-vars */
// import React, { useEffect, useState } from "react";
// import "./Promises.css";
// import { useParams } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchAllLoans } from "../../redux/slices/loan/loanReportSlice";
// import { fetchCustomers } from "../../redux/slices/Customer/customerReportSlice";
// import { toast } from "react-toastify";
// import jsPDF from "jspdf";
// import html2canvas from "html2canvas";

// const Promises = () => {
//   const { loanId } = useParams();
//   const dispatch = useDispatch();
//   const superAdminId = Number(localStorage.getItem("userId")) || 0;

//   const { loans, loading: loanLoading, error: loanError } = useSelector(
//     (state) => state.loanReport
//   );
//   const { customers, loading: customerLoading, error: customerError } =
//     useSelector((state) => state.customerReport);
//   const { profile } = useSelector((state) => state.userProfile);

//   const [loan, setLoan] = useState(null);
//   const [customer, setCustomer] = useState(null);
//   const [company, setCompany] = useState(null);


//   const [branch, setBranch] = useState(null); // 

//   useEffect(() => {
//     const loadData = async () => {
//       try {
//         const loanAction = await dispatch(fetchAllLoans());
//         if (!fetchAllLoans.fulfilled.match(loanAction)) {
//           toast.error("Failed to fetch loan details");
//           return;
//         }
//         const loanList = loanAction.payload?.data || loanAction.payload || [];
//         const foundLoan = loanList.find((l) => String(l.id) === String(loanId));
//         if (!foundLoan) {
//           toast.error("Loan not found for this ID");
//           return;
//         }
//         setLoan(foundLoan);

//         const customerId = foundLoan.customerId || foundLoan.userId;
//         if (customerId) {
//           const customerAction = await dispatch(
//             fetchCustomers({ page: 1, limit: 1000 })
//           );
//           if (fetchCustomers.fulfilled.match(customerAction)) {
//             const customerList =
//               customerAction.payload?.data || customerAction.payload || [];
//             const foundCustomer = customerList.find(
//               (c) =>
//                 String(c.id) === String(customerId) ||
//                 String(c.userId) === String(customerId)
//             );
//             if (foundCustomer) setCustomer(foundCustomer);
//             else toast.warn("Customer not found for this loan");
//           } else {
//             toast.error("Failed to fetch customer details");
//           }
//         }

//         if (profile && profile.superAdminId) {
//           try {
//             const res = await fetch(
//               `https://payyug.in/api/get-company?superAdminId=${profile.superAdminId}`
//             );
//             if (!res.ok) throw new Error("Failed to fetch company info");
//             const data = await res.json();
//             const companyInfo = data.data || data;
//             if (companyInfo.logo) {
//               companyInfo.logoUrl = `https://payyug.in/${companyInfo.logo.replace(
//                 /^images\//,
//                 ""
//               )}`;
//             }
//             setCompany(companyInfo);
//           } catch (err) {
//             console.error("Failed to fetch company details:", err);
//           }
//         }





// if (profile.branchId) {
//           try {
//             const res = await fetch(
//               `https://payyug.in/api/get-byId/119`
//             );
//             if (!res.ok) throw new Error("Failed to fetch branch info");
//             const branchData = await res.json();
//             setBranch(branchData.data || branchData);
//           } catch (err) {
//             console.error("Failed to fetch branch details:", err);
//           }
//         }



        
//       } catch (err) {
//         console.error(err);
//         toast.error("Error fetching data");
//       }
//     };

//     loadData();
//   }, [dispatch, loanId, superAdminId, profile]);

//   const handleDownloadPDF = async () => {
//     const input = document.querySelector(".Sanc-letter-container");
//     const button = document.querySelector(".loan-application-print-button");
//     if (!input) return;

//     if (button) button.style.display = "none";

//     await new Promise((resolve) => {
//       const images = input.querySelectorAll("img");
//       let loaded = 0;
//       if (images.length === 0) resolve();
//       images.forEach((img) => {
//         if (img.complete) {
//           loaded++;
//           if (loaded === images.length) resolve();
//         } else {
//           img.onload = img.onerror = () => {
//             loaded++;
//             if (loaded === images.length) resolve();
//           };
//         }
//       });
//     });

//     const canvas = await html2canvas(input, {
//       scale: 2,
//       useCORS: true,
//       logging: false,
//     });
//     const imgData = canvas.toDataURL("image/png");
//     const pdf = new jsPDF("p", "mm", "a4");
//     const imgWidth = 210;
//     const pageHeight = 297;
//     const imgHeight = (canvas.height * imgWidth) / canvas.width;
//     let heightLeft = imgHeight;
//     let position = 0;

//     pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
//     heightLeft -= pageHeight;

//     while (heightLeft > 0) {
//       position = heightLeft - imgHeight;
//       pdf.addPage();
//       pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
//       heightLeft -= pageHeight;
//     }

//     pdf.save(`PromiseLetter_${loanId}.pdf`);

//     if (button) button.style.display = "block";
//   };

//   if (loanLoading || customerLoading) {
//     return (
//       <div className="Sanc-letter-container">
//         <p>Loading details...</p>
//       </div>
//     );
//   }

//   if (loanError || customerError) {
//     return (
//       <div className="Sanc-letter-container">
//         <p style={{ color: "red" }}>{loanError || customerError}</p>
//       </div>
//     );
//   }

//   if (!loan) {
//     return (
//       <div className="Sanc-letter-container">
//         <p>No loan data available.</p>
//       </div>
//     );
//   }

//   const customerData = customer || {};
//   const loanHolderName = customerData.fullName || loan.userName || "N/A";
//   const companyName = company?.name || "Company Name";

//   const street = (customerData.address || loan.address || "N/A").replace(
//     /\n/g,
//     ", "
//   );
//   const subDistrict = customerData.subDistrict || loan.subDistrict || "";
//   const district = customerData.district || loan.district || "N/A";
//   const state = customerData.state || loan.state || "N/A";
//   const pincode = customerData.pincode || loan.pincode || "N/A";
//   const fullAddress = `${street}${
//     subDistrict ? ", " + subDistrict : ""
//   }, ${district}, ${state} - ${pincode}`;
//    const placeAddress = branch
//     ? `${branch.address}, ${branch.city}, ${branch.state} - ${branch.country || ""}`
//     : "N/A";


//   return (
//     <div className="Sanc-letter-container">
//       <div className="Sancletter-header">
//         <div className="Sanclogo-box">
//           <img
//             src={company?.logoUrl || "/logo.png"}
//             alt="logo"
//             crossOrigin="anonymous"
//           />
//         </div>

//         <div className="Sanccompany-details Sanccompany-right-vertical">
//           <div>
//             <h2>{companyName}</h2>
//           </div>
//           <div>
//             <span>
//               <strong>CIN:</strong> {company?.cin || "N/A"}
//             </span>
//           </div>
//           <div>
//             <span>
//               <strong>Mobile No:</strong> {company?.contact || "N/A"}
//             </span>
//           </div>
//           <div>
//             <span>
//               <strong>Email ID:</strong>{" "}
//               {customerData.email || loan.email || company?.email || "N/A"}
//             </span>
//           </div>
//           <div>
//             <span>
//               <strong>Address:</strong> {company?.address || fullAddress}
//             </span>
//           </div>
//           <div>
//             <span>
//               <strong>Branch Name:</strong> {branch?.name || ""}
//             </span>
//           </div>
//         </div>
//       </div>
// <h3 className="title-center">DEMAND PROMISSORY NOTE</h3>
//         <div className="date-place">
//         <p><strong>Date:</strong> {loan.createdAt ? loan.createdAt.slice(0, 10) : "N/A"}</p>
//         <p><strong>Place:</strong> {placeAddress}</p>
//       </div>

      
//       <p>
//         <strong>{companyName}</strong> मैं श्री / श्रीमती{" "}
//         <strong>{loanHolderName}</strong> c/o निवासी{" "}
//         <strong>{fullAddress}</strong> का मूल निवासी हूँ,{" "}
//         <strong>{companyName}</strong> द्वारा मांगे जाने पर मेरे द्वारा प्राप्त की
//         गई ऋण राशि रुपए ₹ <strong>{loan.loanAmount || "N/A"}</strong> को मैं अपने
//         ऋण चुकौती की अनुसूची के अनुसार ईएमआई किस्तों का भुगतना करने का वादा करता
//         / करती हूं।
//       </p>

//       <p>
//         <br />
//         <strong>Amount : ₹ {loan.loanAmount || "N/A"}</strong>
//       </p>
//       <p>
//         This is to certify that I, <strong>{loanHolderName}</strong> C/O,
//         resident at <strong>{fullAddress}</strong> has taken a loan of amount{" "}
//         <strong>Rs. {loan.loanAmount || "N/A"}</strong> from{" "}
//         <strong>{companyName}</strong>. I hereby promise to pay the EMI
//         instalments as per the schedule of my loan repayment that was previously
//         checked and signed by me in the Loan Application Form.
//       </p>

//       <br />
//       <br />
    

//          <div className="stamp-box-section">
//         <div className="stamp-box">Affix ₹1 Revenue Stamp</div>
//       </div>

//       <table className="Promises-Signature-table">
//         <tbody>
//           <tr>
//             <td>
//               Member Signature <br /> (सदस्य के हस्ताक्षर)
//               <div style={{ height: "80px" }}></div>
//             </td>
//             <td>
//               Spouse Signature <br /> (जीवनसाथी के हस्ताक्षर)
//               <div style={{ height: "80px" }}></div>
//             </td>
//             <td>
//               Branch Seal With Signature <br /> (शाखा मोहर के साथ हस्ताक्षर)
//               <div style={{ height: "80px" }}></div>
//             </td>
//           </tr>
//         </tbody>
//       </table>

//       {/* ✅ Stamp Box Section */}
   

//       <div className="loan-application-print-button">
//         <button onClick={handleDownloadPDF}>Download PDF</button>
//       </div>
//     </div>
//   );
// };

// export default Promises;




/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useRef } from "react";
import "./Promises.css";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllLoans } from "../../redux/slices/loan/loanReportSlice";
import { fetchCustomers } from "../../redux/slices/Customer/customerReportSlice";
import { toast } from "react-toastify";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import axios from "axios";

const Promises = () => {
  const { loanId } = useParams();
  const dispatch = useDispatch();
  const letterRef = useRef(null);
  const superAdminId = Number(localStorage.getItem("userId")) || 0;

  const { loans, loading: loanLoading, error: loanError } = useSelector(
    (state) => state.loanReport
  );
  const { customers, loading: customerLoading, error: customerError } =
    useSelector((state) => state.customerReport);
  const { profile } = useSelector((state) => state.userProfile);

  const [loan, setLoan] = useState(null);
  const [customer, setCustomer] = useState(null);
  const [company, setCompany] = useState(null);
  const [branch, setBranch] = useState(null);

  const [branchSealUrl, setBranchSealUrl] = useState(null);
  const [branchSignUrl, setBranchSignUrl] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      try {
        const loanAction = await dispatch(fetchAllLoans());
        if (!fetchAllLoans.fulfilled.match(loanAction)) {
          toast.error("Failed to fetch loan details");
          return;
        }
        const loanList = loanAction.payload?.data || loanAction.payload || [];
        const foundLoan = loanList.find((l) => String(l.id) === String(loanId));
        if (!foundLoan) {
          toast.error("Loan not found for this ID");
          return;
        }
        setLoan(foundLoan);

        const customerId = foundLoan.customerId || foundLoan.userId;
        if (customerId) {
          const customerAction = await dispatch(
            fetchCustomers({
              page: 1,
              limit: 1000,
              superAdminId: profile?.superAdminId,
            })
          );
          if (fetchCustomers.fulfilled.match(customerAction)) {
            const customerList =
              customerAction.payload?.data || customerAction.payload || [];
            const foundCustomer = customerList.find(
              (c) =>
                String(c.id) === String(customerId) ||
                String(c.userId) === String(customerId)
            );
            if (foundCustomer) setCustomer(foundCustomer);
            else toast.warn("Customer not found for this loan");
          } else {
            toast.error("Failed to fetch customer details");
          }
        }

        if (profile && profile.superAdminId) {
          try {
            const res = await fetch(
              `https://payyug.in/api/get-company?superAdminId=${profile.superAdminId}`
            );
            if (!res.ok) throw new Error("Failed to fetch company info");
            const data = await res.json();
            const companyInfo = data.data || data;
            if (companyInfo.logo) {
              companyInfo.logoUrl = `https://payyug.in/${companyInfo.logo.replace(
                /^images\//,
                ""
              )}`;
            }
            setCompany(companyInfo);
          } catch (err) {
            console.error("Failed to fetch company details:", err);
          }
        }

        if (profile?.branchId) {
          try {
            const res = await fetch(
              `https://payyug.in/api/get-byId/${profile.branchId}`
            );
            if (!res.ok) throw new Error("Failed to fetch branch info");
            const branchData = await res.json();
            setBranch(branchData.data || branchData);
          } catch (err) {
            console.error("Failed to fetch branch details:", err);
          }
        }
      } catch (err) {
        console.error(err);
      }
    };

    loadData();
  }, [dispatch, loanId, superAdminId, profile]);

  useEffect(() => {
    const fetchSealSign = async () => {
      if (!profile?.superAdminId) return;

      try {
        const res = await axios.get(
          `https://payyug.in/api/list/stamp?superAdminId=${profile?.superAdminId}&category=Loan Promise`
        );

        const dataArray = res?.data?.data?.[0] || [];

        if (dataArray && dataArray.file) {
          const cleanSealPath = dataArray.file.replace(/^images\//, "");
          setBranchSealUrl(`https://payyug.in/${cleanSealPath}`);
        } else {
          setBranchSealUrl(null);
        }

        if (dataArray && dataArray.type) {
          const cleanSignPath = dataArray.type.replace(/^images\//, "");
          setBranchSignUrl(`https://payyug.in/${cleanSignPath}`);
        } else {
          setBranchSignUrl(null);
        }
      } catch (error) {
        console.error("API Fetch Error:", error);
      }
    };

    fetchSealSign();
  }, [profile?.superAdminId]);

  /* ================== PDF Download Function ================== */
  const handleDownloadPDF = async () => {
    const input = letterRef.current;
    if (!input) return;

    const actionButtons = document.querySelectorAll(".loan-application-print-button");
    actionButtons.forEach((btn) => (btn.style.display = "none"));

    try {
      const pdf = new jsPDF({
        orientation: "p",
        unit: "mm",
        format: "a4",
        compress: true,
      });

      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const margin = 10;
      const contentWidth = pageWidth - margin * 2;
      const contentHeight = pageHeight - margin * 2;

      const canvas = await html2canvas(input, {
        scale: 1.5,
        useCORS: true,
        backgroundColor: "#ffffff",
        scrollY: -window.scrollY,
      });

      const imgWidth = canvas.width;
      const pixelPageHeight = (imgWidth * contentHeight) / contentWidth;

      const breakElements = input.querySelectorAll(
        ".Sancletter-header, .title-center, .date-place, p, .stamp-box-section, .Promises-Signature-table"
      );
      const containerRect = input.getBoundingClientRect();
      let breakPoints = [];

      breakElements.forEach((el) => {
        const rect = el.getBoundingClientRect();
        const relativeTop = (rect.top - containerRect.top) * 1.5;
        breakPoints.push(relativeTop);
      });

      let heightLeft = canvas.height;
      let sY = 0;

      while (heightLeft > 0) {
        let sHeight = pixelPageHeight;

        if (heightLeft > pixelPageHeight) {
          const expectedPageEnd = sY + pixelPageHeight;
          let bestBreakPoint = expectedPageEnd;

          for (let i = 0; i < breakPoints.length; i++) {
            if (breakPoints[i] > sY + 40 && breakPoints[i] < expectedPageEnd) {
              bestBreakPoint = breakPoints[i];
            }
          }

          sHeight = bestBreakPoint - sY;
        } else {
          sHeight = heightLeft;
        }

        const pageCanvas = document.createElement("canvas");
        pageCanvas.width = imgWidth;
        pageCanvas.height = sHeight;

        const ctx = pageCanvas.getContext("2d");
        ctx.fillStyle = "#ffffff";
        ctx.fillRect(0, 0, pageCanvas.width, pageCanvas.height);
        ctx.drawImage(canvas, 0, sY, imgWidth, sHeight, 0, 0, imgWidth, sHeight);

        const pageImgData = pageCanvas.toDataURL("image/jpeg", 0.75);
        const displayHeight_mm = (sHeight * contentWidth) / imgWidth;

        if (sY > 0) pdf.addPage();

        pdf.addImage(
          pageImgData,
          "JPEG",
          margin,
          margin,
          contentWidth,
          displayHeight_mm,
          undefined,
          "FAST"
        );

        sY += sHeight;
        heightLeft -= sHeight;
      }

      pdf.save(`${customerData?.fullName || loan?.userName || "Customer"}_LoanPromiseLetter.pdf`);
    } catch (error) {
      console.error("PDF Download Error:", error);
    } finally {
      actionButtons.forEach((btn) => (btn.style.display = "flex"));
    }
  };

  /* ================== Print Function ================== */
  const triggerPrintElement = (elementRef, title = "Print_Document") => {
    const input = elementRef.current;
    if (!input) return;

    const existingIframe = document.getElementById("print-iframe");
    if (existingIframe) {
      document.body.removeChild(existingIframe);
    }

    const iframe = document.createElement("iframe");
    iframe.id = "print-iframe";
    iframe.style.position = "absolute";
    iframe.style.left = "-9999px";
    iframe.style.top = "0";
    iframe.style.width = "1024px";
    iframe.style.height = "auto";
    iframe.style.border = "none";
    document.body.appendChild(iframe);

    const doc = iframe.contentWindow.document;

    let extractedStyles = "";
    document.querySelectorAll("style, link[rel='stylesheet']").forEach((node) => {
      extractedStyles += node.outerHTML;
    });

    doc.open();
    doc.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>${title}</title>
          ${extractedStyles}
          <style>
            @page {
              size: A4 portrait;
              margin: 8mm 10mm;
            }
            *, *::before, *::after {
              -webkit-print-color-adjust: exact !important;
              print-color-adjust: exact !important;
              box-sizing: border-box !important;
              visibility: visible !important;
              opacity: 1 !important;
            }
            body {
              background: #ffffff !important;
              color: #000000 !important;
              font-family: Arial, Helvetica, sans-serif !important;
              margin: 0 !important;
              padding: 0 !important;
            }
            .Sanc-letter-container {
              width: 100% !important;
              max-width: 100% !important;
              margin: 0 auto !important;
              padding: 0 !important;
              border: none !important;
              box-shadow: none !important;
            }
            .Sancletter-header {
              display: flex !important;
              flex-direction: row !important;
              justify-content: space-between !important;
              align-items: center !important;
              padding: 10px 14px !important;
              border-bottom: 1.5px solid #000000 !important;
            }
            .Sanclogo-box {
              width: 85px !important;
              height: 85px !important;
              display: flex !important;
              align-items: center !important;
              justify-content: center !important;
              overflow: hidden !important;
              flex-shrink: 0 !important;
            }
            .Sanclogo-box img {
              max-width: 100% !important;
              max-height: 100% !important;
              width: auto !important;
              height: auto !important;
              object-fit: contain !important;
              border-radius: 50% !important;
              display: block !important;
            }
            .Sanccompany-details {
              text-align: center !important;
              flex: 1 !important;
            }
            .Sanccompany-details h2 {
              font-size: 16px !important;
              font-weight: bold !important;
              margin: 0 0 4px 0 !important;
              color: #000000 !important;
            }
            .Sanccompany-details span {
              display: block !important;
              font-size: 10px !important;
              line-height: 1.35 !important;
              margin: 1px 0 !important;
              color: #000000 !important;
            }
            .title-center {
              text-align: center !important;
              font-size: 14px !important;
              font-weight: bold !important;
              text-decoration: underline !important;
              margin: 12px 0 8px 0 !important;
            }
            .date-place {
              display: flex !important;
              justify-content: space-between !important;
              margin: 10px 0 !important;
              font-size: 11px !important;
            }
            p {
              font-size: 11px !important;
              line-height: 1.6 !important;
              margin: 10px 0 !important;
              text-align: justify !important;
              color: #000000 !important;
            }
            .stamp-box-section {
              margin: 15px 0 !important;
              display: flex !important;
              justify-content: flex-end !important;
            }
            .stamp-box {
              width: 90px !important;
              height: 100px !important;
              border: 1px dashed #000000 !important;
              display: flex !important;
              align-items: center !important;
              justify-content: center !important;
              text-align: center !important;
              font-size: 10px !important;
            }
            table, .Promises-Signature-table {
              width: 100% !important;
              border-collapse: collapse !important;
              color: #000000 !important;
              margin-top: 20px !important;
            }
            th, td {
              border: 1px solid #000000 !important;
              padding: 8px 6px !important;
              font-size: 10px !important;
              text-align: center !important;
              vertical-align: top !important;
            }
            .footer-seal-sign {
              display: flex !important;
              flex-direction: column !important;
              align-items: center !important;
              justify-content: center !important;
              gap: 4px !important;
              margin-top: 6px !important;
            }
            .footer-seal img {
              width: 55px !important;
              height: 55px !important;
              object-fit: contain !important;
              display: block !important;
            }
            .footer-sign img {
              width: 100px !important;
              height: 35px !important;
              object-fit: contain !important;
              display: block !important;
            }
            img {
              display: inline-block !important;
              visibility: visible !important;
              max-width: 100% !important;
              -webkit-print-color-adjust: exact !important;
              print-color-adjust: exact !important;
            }
            button, .loan-application-print-button, [class*="download-btn"], [class*="print-btn"] {
              display: none !important;
            }
          </style>
        </head>
        <body>
          <div class="Sanc-letter-container">
            ${input.innerHTML}
          </div>
        </body>
      </html>
    `);
    doc.close();

    const checkAndPrint = () => {
      const iframeImages = doc.querySelectorAll("img");
      const promises = Array.from(iframeImages).map((img) => {
        if (img.complete) return Promise.resolve();
        return new Promise((resolve) => {
          img.onload = resolve;
          img.onerror = resolve;
        });
      });

      Promise.all(promises).then(() => {
        setTimeout(() => {
          iframe.contentWindow.focus();
          iframe.contentWindow.print();
        }, 250);
      });
    };

    if (doc.readyState === "complete") {
      checkAndPrint();
    } else {
      iframe.contentWindow.onload = checkAndPrint;
    }
  };

  const handlePrint = () => {
    triggerPrintElement(
      letterRef,
      `${customerData?.fullName || loan?.userName || "Customer"}_LoanPromiseLetter`
    );
  };

  if (loanLoading || customerLoading) {
    return (
      <div className="Sanc-letter-container">
        <p>Loading details...</p>
      </div>
    );
  }

  if (loanError || customerError) {
    return (
      <div className="Sanc-letter-container">
        <p style={{ color: "red" }}>{loanError || customerError}</p>
      </div>
    );
  }

  if (!loan) {
    return (
      <div className="Sanc-letter-container">
        <p>No loan data available.</p>
      </div>
    );
  }

  const customerData = customer || {};
  const loanHolderName = customerData.fullName || loan.userName || "N/A";
  const guardianName = customerData.guardianName || loan.guardianName || null;
  const companyName = company?.name || "Company Name";

  const district = customerData.district || loan.district || "N/A";
  const state = customerData.state || loan.state || "N/A";
  const pincode = customerData.pincode || loan.pincode || "N/A";
  const fullAddress = `${district}, ${state} - ${pincode}`;
  const placeAddress = branch
    ? `${branch.address}, ${branch.city}, ${branch.state} - ${branch.country || ""}`
    : "N/A";

  return (
    <div>
      <div className="Sanc-letter-container" ref={letterRef}>
        {/* Header */}
        <div className="Sancletter-header">
          <div className="Sanclogo-box">
            <img
              src={company?.logoUrl || "/logo.png"}
              alt="logo"
              crossOrigin="anonymous"
            />
          </div>

          <div className="Sanccompany-details Sanccompany-right-vertical">
            <div>
              <h2>{companyName}</h2>
            </div>
            <div>
              <span>
                <strong>CIN:</strong> {company?.cin || "N/A"}
              </span>
            </div>
            <div>
              <span>
                <strong>Regt. Office:</strong> {company?.address || "N/A"}
              </span>
            </div>
            <div>
              <span>
                <strong>Branch Name:</strong> {branch?.name || profile?.branchName || "N/A"}
              </span>
            </div>
            <div>
              <span>
                <strong>Mobile No:</strong> {company?.contact || "N/A"}
              </span>
            </div>
            <div>
              <span>
                <strong>Email ID:</strong> {company?.email || "N/A"}
              </span>
            </div>
          </div>
          {/* <div style={{ width: "85px", flexShrink: 0 }}></div> */}
        </div>

        <h3 className="title-center">DEMAND PROMISSORY NOTE</h3>
        <div className="date-place">
          <p>
            <strong>Date:</strong>{" "}
            {loan.createdAt
              ? new Date(loan.createdAt).toLocaleDateString("en-GB")
              : "N/A"}
          </p>
          <p>
            <strong>Place:</strong> {placeAddress}
          </p>
        </div>

        {/* Hindi Section */}
        <p>
          <strong>{companyName}</strong> मैं श्री / श्रीमती{" "}
          <strong>{loanHolderName}</strong>
          {guardianName ? ` C/O ${guardianName}` : ""} निवासी{" "}
          <strong>{fullAddress}</strong> का मूल निवासी हूँ,{" "}
          <strong>{companyName}</strong> द्वारा मांगे जाने पर मेरे द्वारा प्राप्त की गई ऋण राशि रुपए ₹{" "}
          <strong>{loan.loanAmount || "N/A"}</strong> को मैं अपने ऋण चुकौती की अनुसूची के अनुसार
          ईएमआई किस्तों का भुगतान करने का वादा करता / करती हूं।
        </p>

        {/* English Section */}
        <p>
          This is to certify that I, <strong>{loanHolderName}</strong>
          {guardianName ? ` C/O ${guardianName}` : ""}, resident at{" "}
          <strong>{fullAddress}</strong> have taken a loan of amount{" "}
          <strong>Rs. {loan.loanAmount || "N/A"}</strong> from{" "}
          <strong>{companyName}</strong>. I hereby promise to pay the EMI instalments as per
          the schedule of my loan repayment that was previously checked and signed by me in the Loan Application Form.
        </p>

        <p>
          <strong>Amount: ₹ {loan.loanAmount || "N/A"}</strong>
        </p>

        {/* Stamp Box */}
        <div className="stamp-box-section">
          <div className="stamp-box">Affix ₹1 Revenue Stamp</div>
        </div>

        {/* Signature Table */}
        <table className="Promises-Signature-table">
          <tbody>
            <tr>
              <td>
                Member Signature <br /> (सदस्य के हस्ताक्षर)
                <div style={{ borderTop: "1px solid #000", marginTop: "20px" }}></div>
              </td>
              <td>
                Spouse Signature <br /> (जीवनसाथी के हस्ताक्षर)
                <div style={{ borderTop: "1px solid #000", marginTop: "20px" }}></div>
              </td>
              <td>
                Branch Seal With Signature <br /> (शाखा मोहर के साथ हस्ताक्षर)
                <div style={{ borderTop: "1px solid #000", marginTop: "20px" }}></div>
                <div className="footer-seal-sign box-size">
                  {branchSealUrl && (
                    <div className="footer-seal">
                      <img src={branchSealUrl} alt="Seal" />
                    </div>
                  )}

                  {branchSignUrl && (
                    <div className="footer-sign">
                      <img src={branchSignUrl} alt="Signature" />
                    </div>
                  )}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div
        className="loan-application-print-button"
        style={{
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          gap: "12px",
          marginTop: "16px",
        }}
      >
        <button
          onClick={handlePrint}
          style={{
            padding: "9px 18px",
            backgroundColor: "#0a74da",
            color: "#ffffff",
            border: "none",
            borderRadius: "6px",
            fontSize: "13px",
            fontWeight: "600",
            cursor: "pointer",
          }}
        >
          🖨️ Print
        </button>

        <button
          onClick={handleDownloadPDF}
          style={{
            padding: "9px 18px",
            backgroundColor: "#0a74da",
            color: "#ffffff",
            border: "none",
            borderRadius: "6px",
            fontSize: "13px",
            fontWeight: "600",
            cursor: "pointer",
          }}
        >
          📄 Download PDF
        </button>
      </div>
    </div>
  );
};

export default Promises;